export interface MobileUsageTypeDetail {
  data: number
  voice: number
  sms: number
  mms: number
  paymentService: number
}
export interface MobileUsageTypeDetailObject {
  data: { amount: number; cost: number; type: string }
  voice: { amount: number; cost: number; type: string }
  sms: { amount: number; cost: number; type: string }
  mms: { amount: number; cost: number; type: string }
  paymentService: { amount: number; cost: number; type: string }
}
export interface MobileUsageSummaryType {
  national: MobileUsageTypeDetail
  roaming: MobileUsageTypeDetail
  international: MobileUsageTypeDetail
  premium: MobileUsageTypeDetail
  roamingOutOfEU: MobileUsageTypeDetail
}
export interface MobileUsageType {
  national: MobileUsageTypeDetailObject
  roaming: MobileUsageTypeDetailObject
  international: MobileUsageTypeDetailObject
  premium: MobileUsageTypeDetailObject
  roamingOutOfEU: MobileUsageTypeDetailObject
}

export interface MobileUsageData {
  date: string
  usage: MobileUsageType
  summary: MobileUsageTypeDetail
  summaryCost: MobileUsageTypeDetail
}
export interface MobileUsage {
  dateFrom: Date | undefined
  dateTo: Date | undefined
  period: string
  subscriber: string | undefined
  data: MobileUsageData[] | undefined
  summary: MobileUsageSummaryType | undefined
  summaryCost: MobileUsageSummaryType | undefined
  globalSummary: MobileUsageTypeDetail | undefined
  globalSummaryCost: MobileUsageTypeDetail | undefined
}

export interface MobileUsageRequest {
  dateFrom: Date | undefined
  dateTo: Date | undefined
  subscriber: string
  period: string
}
export interface MobileUDataUsageType {
  used: number
  max: number
  outOfBundle: number
  unit: string
}

export const isMobileUsage = (usage: any): usage is Array<MobileUsage> => {
  if (usage === undefined) {
    return false
  }
  if (Array.isArray(usage)) {
    return 'data' in usage[0]
  }
  return 'data' in usage
}

export const isMobileUsageRequest = (usage: any): usage is MobileUsageRequest => {
  if (usage === undefined) {
    return false
  }
  return 'dateFrom' in usage && 'subscriber' in usage
}
